// extracted by mini-css-extract-plugin
export default {"product__list":"ProductCardMain_product__list__T3qdo","product__card":"ProductCardMain_product__card__hYdFR"};